exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.labelTabs[data-v-28406ead] {\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.77) !important;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  text-align: center;\n}\n", ""]);

// exports
